export { default } from './login-with-different-account';
